export default "__VITE_ASSET__BFq8E21i__"